// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/ryugu/v1/execution_scope.proto (package mono.ryugu.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ExecutionArtifactKind, ExecutionAuthorityEventType, ExecutionClaimType, ExecutionCommercialTreatment, ExecutionContractChangeSetType, ExecutionEntityLinkVerdict, ExecutionPerformanceDisposition, ExecutionReviewRequirement, ExecutionScopeArtifactRelation, ExecutionScopeAssessment, ExecutionScopeLineRole, ExecutionScopeRevisionState, ExecutionScopeScopeRelation, ExecutionTrackingMode } from "../../common/v1/execution_scope_pb";
/**
 * ExecutionScopeSummary is the roster/list projection of a workstream.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeSummary
 */ export class ExecutionScopeSummary extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string display_name = 3;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string scope_type = 4;
   */ _define_property(this, "scopeType", ""), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string current_revision_id = 6;
   */ _define_property(this, "currentRevisionId", ""), /**
   * @generated from field: string current_version_label = 7;
   */ _define_property(this, "currentVersionLabel", ""), /**
   * @generated from field: mono.common.v1.ExecutionScopeRevisionState current_revision_state = 8;
   */ _define_property(this, "currentRevisionState", ExecutionScopeRevisionState.UNSPECIFIED), /**
   * @generated from field: int32 commitment_count = 9;
   */ _define_property(this, "commitmentCount", 0), /**
   * @generated from field: int32 unresolved_count = 10;
   */ _define_property(this, "unresolvedCount", 0), /**
   * @generated from field: int32 work_item_count = 11;
   */ _define_property(this, "workItemCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeSummary, "runtime", proto3);
_define_property(ExecutionScopeSummary, "typeName", "mono.ryugu.v1.ExecutionScopeSummary");
_define_property(ExecutionScopeSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "current_revision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "current_version_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "current_revision_state",
            kind: "enum",
            T: proto3.getEnumType(ExecutionScopeRevisionState)
        },
        {
            no: 9,
            name: "commitment_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "unresolved_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "work_item_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ExecutionScopeAggregate is the GetExecutionScope projection. Detailed source
 * references and large instance rosters remain paginated/lazy.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeAggregate
 */ export class ExecutionScopeAggregate extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeAggregate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeAggregate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeAggregate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeAggregate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ExecutionScopeSummary scope = 1;
   */ _define_property(this, "scope", void 0), /**
   * @generated from field: string current_revision_id = 2;
   */ _define_property(this, "currentRevisionId", ""), /**
   * @generated from field: string current_version_label = 3;
   */ _define_property(this, "currentVersionLabel", ""), /**
   * @generated from field: mono.common.v1.ExecutionScopeRevisionState current_revision_state = 4;
   */ _define_property(this, "currentRevisionState", ExecutionScopeRevisionState.UNSPECIFIED), /**
   * @generated from field: repeated mono.ryugu.v1.ExecutionScopeRevisionSummary revision_history_summary = 5;
   */ _define_property(this, "revisionHistorySummary", []), /**
   * @generated from field: repeated mono.ryugu.v1.ExecutionScopeDocumentSummary governing_documents = 6;
   */ _define_property(this, "governingDocuments", []), /**
   * @generated from field: mono.ryugu.v1.ExecutionScopeAuthoritySummary authority_summary = 7;
   */ _define_property(this, "authoritySummary", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.ExecutionScopeLineLinkSummary line_links = 8;
   */ _define_property(this, "lineLinks", []), /**
   * @generated from field: mono.ryugu.v1.ExecutionScopeCommitmentCounts commitment_counts = 9;
   */ _define_property(this, "commitmentCounts", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.ExecutionScopeCommitmentSummary commitments = 10;
   */ _define_property(this, "commitments", []), /**
   * @generated from field: mono.ryugu.v1.ExecutionScopeWorkProductSummary work_products_summary = 11;
   */ _define_property(this, "workProductsSummary", void 0), /**
   * @generated from field: repeated mono.ryugu.v1.ExecutionScopeRelatedScope related_scopes = 12;
   */ _define_property(this, "relatedScopes", []), /**
   * @generated from field: int32 conflict_count = 13;
   */ _define_property(this, "conflictCount", 0), /**
   * @generated from field: int32 unresolved_count = 14;
   */ _define_property(this, "unresolvedCount", 0), /**
   * @generated from field: int32 active_deviation_count = 15;
   */ _define_property(this, "activeDeviationCount", 0), /**
   * @generated from field: mono.ryugu.v1.ExecutionScopeTimelineSummary timeline_summary = 16;
   */ _define_property(this, "timelineSummary", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeAggregate, "runtime", proto3);
_define_property(ExecutionScopeAggregate, "typeName", "mono.ryugu.v1.ExecutionScopeAggregate");
_define_property(ExecutionScopeAggregate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope",
            kind: "message",
            T: ExecutionScopeSummary
        },
        {
            no: 2,
            name: "current_revision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "current_version_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "current_revision_state",
            kind: "enum",
            T: proto3.getEnumType(ExecutionScopeRevisionState)
        },
        {
            no: 5,
            name: "revision_history_summary",
            kind: "message",
            T: ExecutionScopeRevisionSummary,
            repeated: true
        },
        {
            no: 6,
            name: "governing_documents",
            kind: "message",
            T: ExecutionScopeDocumentSummary,
            repeated: true
        },
        {
            no: 7,
            name: "authority_summary",
            kind: "message",
            T: ExecutionScopeAuthoritySummary
        },
        {
            no: 8,
            name: "line_links",
            kind: "message",
            T: ExecutionScopeLineLinkSummary,
            repeated: true
        },
        {
            no: 9,
            name: "commitment_counts",
            kind: "message",
            T: ExecutionScopeCommitmentCounts
        },
        {
            no: 10,
            name: "commitments",
            kind: "message",
            T: ExecutionScopeCommitmentSummary,
            repeated: true
        },
        {
            no: 11,
            name: "work_products_summary",
            kind: "message",
            T: ExecutionScopeWorkProductSummary
        },
        {
            no: 12,
            name: "related_scopes",
            kind: "message",
            T: ExecutionScopeRelatedScope,
            repeated: true
        },
        {
            no: 13,
            name: "conflict_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "unresolved_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "active_deviation_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 16,
            name: "timeline_summary",
            kind: "message",
            T: ExecutionScopeTimelineSummary
        }
    ]));
/**
 * ExecutionScopeRevisionSummary is a compact revision-history row.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeRevisionSummary
 */ export class ExecutionScopeRevisionSummary extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeRevisionSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeRevisionSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeRevisionSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeRevisionSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string version_label = 2;
   */ _define_property(this, "versionLabel", ""), /**
   * @generated from field: mono.common.v1.ExecutionScopeRevisionState revision_state = 3;
   */ _define_property(this, "revisionState", ExecutionScopeRevisionState.UNSPECIFIED), /**
   * @generated from field: google.protobuf.Timestamp approved_at = 4;
   */ _define_property(this, "approvedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_from = 5;
   */ _define_property(this, "effectiveFrom", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_to = 6;
   */ _define_property(this, "effectiveTo", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_start = 7;
   */ _define_property(this, "popStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_end = 8;
   */ _define_property(this, "popEnd", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeRevisionSummary, "runtime", proto3);
_define_property(ExecutionScopeRevisionSummary, "typeName", "mono.ryugu.v1.ExecutionScopeRevisionSummary");
_define_property(ExecutionScopeRevisionSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "revision_state",
            kind: "enum",
            T: proto3.getEnumType(ExecutionScopeRevisionState)
        },
        {
            no: 4,
            name: "approved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "effective_from",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "effective_to",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "pop_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "pop_end",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * ExecutionScopeDocumentSummary is a governing-document chip.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeDocumentSummary
 */ export class ExecutionScopeDocumentSummary extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeDocumentSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeDocumentSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeDocumentSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeDocumentSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_document_id = 1;
   */ _define_property(this, "programDocumentId", ""), /**
   * @generated from field: string source_artifact_id = 2;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * @generated from field: mono.common.v1.ExecutionScopeArtifactRelation document_role = 3;
   */ _define_property(this, "documentRole", ExecutionScopeArtifactRelation.UNSPECIFIED), /**
   * @generated from field: mono.common.v1.ExecutionArtifactKind artifact_kind = 4;
   */ _define_property(this, "artifactKind", ExecutionArtifactKind.UNSPECIFIED), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeDocumentSummary, "runtime", proto3);
_define_property(ExecutionScopeDocumentSummary, "typeName", "mono.ryugu.v1.ExecutionScopeDocumentSummary");
_define_property(ExecutionScopeDocumentSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_role",
            kind: "enum",
            T: proto3.getEnumType(ExecutionScopeArtifactRelation)
        },
        {
            no: 4,
            name: "artifact_kind",
            kind: "enum",
            T: proto3.getEnumType(ExecutionArtifactKind)
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ExecutionScopeAuthoritySummary rolls up exercise/funding/authority state.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeAuthoritySummary
 */ export class ExecutionScopeAuthoritySummary extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeAuthoritySummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeAuthoritySummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeAuthoritySummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeAuthoritySummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 exercise_link_count = 1;
   */ _define_property(this, "exerciseLinkCount", 0), /**
   * @generated from field: string authority_state = 2;
   */ _define_property(this, "authorityState", ""), /**
   * @generated from field: string funding_state = 3;
   */ _define_property(this, "fundingState", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeAuthoritySummary, "runtime", proto3);
_define_property(ExecutionScopeAuthoritySummary, "typeName", "mono.ryugu.v1.ExecutionScopeAuthoritySummary");
_define_property(ExecutionScopeAuthoritySummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "exercise_link_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "authority_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "funding_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ExecutionScopeLineLinkSummary is a CLIN/SLIN chip on the aggregate.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeLineLinkSummary
 */ export class ExecutionScopeLineLinkSummary extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeLineLinkSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeLineLinkSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeLineLinkSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeLineLinkSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contract_clin_id = 1;
   */ _define_property(this, "contractClinId", ""), /**
   * @generated from field: string clin_number = 2;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: mono.common.v1.ExecutionScopeLineRole line_role = 3;
   */ _define_property(this, "lineRole", ExecutionScopeLineRole.UNSPECIFIED);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeLineLinkSummary, "runtime", proto3);
_define_property(ExecutionScopeLineLinkSummary, "typeName", "mono.ryugu.v1.ExecutionScopeLineLinkSummary");
_define_property(ExecutionScopeLineLinkSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "line_role",
            kind: "enum",
            T: proto3.getEnumType(ExecutionScopeLineRole)
        }
    ]));
/**
 * ExecutionScopeCommitmentCounts is the coverage-matrix rollup.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeCommitmentCounts
 */ export class ExecutionScopeCommitmentCounts extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeCommitmentCounts().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeCommitmentCounts().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeCommitmentCounts().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeCommitmentCounts, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 performed_here = 1;
   */ _define_property(this, "performedHere", 0), /**
   * @generated from field: int32 fulfilled_elsewhere = 2;
   */ _define_property(this, "fulfilledElsewhere", 0), /**
   * @generated from field: int32 shared_delivery = 3;
   */ _define_property(this, "sharedDelivery", 0), /**
   * @generated from field: int32 waived = 4;
   */ _define_property(this, "waived", 0), /**
   * @generated from field: int32 not_applicable = 5;
   */ _define_property(this, "notApplicable", 0), /**
   * @generated from field: int32 unresolved = 6;
   */ _define_property(this, "unresolved", 0), /**
   * @generated from field: int32 own_series = 7;
   */ _define_property(this, "ownSeries", 0), /**
   * @generated from field: int32 shared_series = 8;
   */ _define_property(this, "sharedSeries", 0), /**
   * @generated from field: int32 no_series = 9;
   */ _define_property(this, "noSeries", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeCommitmentCounts, "runtime", proto3);
_define_property(ExecutionScopeCommitmentCounts, "typeName", "mono.ryugu.v1.ExecutionScopeCommitmentCounts");
_define_property(ExecutionScopeCommitmentCounts, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "performed_here",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "fulfilled_elsewhere",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "shared_delivery",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "waived",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "not_applicable",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "unresolved",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "own_series",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "shared_series",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "no_series",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ExecutionScopeCommitmentSummary is one coverage-matrix row.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeCommitmentSummary
 */ export class ExecutionScopeCommitmentSummary extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeCommitmentSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeCommitmentSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeCommitmentSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeCommitmentSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string contract_obligation_id = 3;
   */ _define_property(this, "contractObligationId", ""), /**
   * @generated from field: string deliverable_definition_id = 4;
   */ _define_property(this, "deliverableDefinitionId", ""), /**
   * @generated from field: mono.common.v1.ExecutionPerformanceDisposition disposition = 5;
   */ _define_property(this, "disposition", ExecutionPerformanceDisposition.UNSPECIFIED), /**
   * @generated from field: mono.common.v1.ExecutionTrackingMode tracking_mode = 6;
   */ _define_property(this, "trackingMode", ExecutionTrackingMode.UNSPECIFIED), /**
   * @generated from field: string program_task_id = 7;
   */ _define_property(this, "programTaskId", ""), /**
   * @generated from field: string fulfilled_by_scope_revision_id = 8;
   */ _define_property(this, "fulfilledByScopeRevisionId", ""), /**
   * @generated from field: string fulfilled_by_commitment_id = 9;
   */ _define_property(this, "fulfilledByCommitmentId", ""), /**
   * @generated from field: string authority_state = 10;
   */ _define_property(this, "authorityState", ""), /**
   * @generated from field: int32 current_instance_count = 11;
   */ _define_property(this, "currentInstanceCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeCommitmentSummary, "runtime", proto3);
_define_property(ExecutionScopeCommitmentSummary, "typeName", "mono.ryugu.v1.ExecutionScopeCommitmentSummary");
_define_property(ExecutionScopeCommitmentSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_obligation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "deliverable_definition_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "disposition",
            kind: "enum",
            T: proto3.getEnumType(ExecutionPerformanceDisposition)
        },
        {
            no: 6,
            name: "tracking_mode",
            kind: "enum",
            T: proto3.getEnumType(ExecutionTrackingMode)
        },
        {
            no: 7,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "fulfilled_by_scope_revision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "fulfilled_by_commitment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "authority_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "current_instance_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ExecutionScopeWorkProductSummary rolls up noncontractual work items.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeWorkProductSummary
 */ export class ExecutionScopeWorkProductSummary extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeWorkProductSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeWorkProductSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeWorkProductSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeWorkProductSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 work_product_count = 1;
   */ _define_property(this, "workProductCount", 0), /**
   * @generated from field: int32 customer_request_count = 2;
   */ _define_property(this, "customerRequestCount", 0), /**
   * @generated from field: int32 potential_scope_growth_count = 3;
   */ _define_property(this, "potentialScopeGrowthCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeWorkProductSummary, "runtime", proto3);
_define_property(ExecutionScopeWorkProductSummary, "typeName", "mono.ryugu.v1.ExecutionScopeWorkProductSummary");
_define_property(ExecutionScopeWorkProductSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "work_product_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "customer_request_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "potential_scope_growth_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ExecutionScopeRelatedScope is a related workstream chip.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeRelatedScope
 */ export class ExecutionScopeRelatedScope extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeRelatedScope().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeRelatedScope().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeRelatedScope().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeRelatedScope, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string scope_id = 1;
   */ _define_property(this, "scopeId", ""), /**
   * @generated from field: string revision_id = 2;
   */ _define_property(this, "revisionId", ""), /**
   * @generated from field: string display_name = 3;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: mono.common.v1.ExecutionScopeScopeRelation relationship_type = 4;
   */ _define_property(this, "relationshipType", ExecutionScopeScopeRelation.UNSPECIFIED);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeRelatedScope, "runtime", proto3);
_define_property(ExecutionScopeRelatedScope, "typeName", "mono.ryugu.v1.ExecutionScopeRelatedScope");
_define_property(ExecutionScopeRelatedScope, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "revision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "relationship_type",
            kind: "enum",
            T: proto3.getEnumType(ExecutionScopeScopeRelation)
        }
    ]));
/**
 * ExecutionScopeTimelineSummary is the compact timeline header.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeTimelineSummary
 */ export class ExecutionScopeTimelineSummary extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeTimelineSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeTimelineSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeTimelineSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeTimelineSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp first_event_at = 1;
   */ _define_property(this, "firstEventAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp last_event_at = 2;
   */ _define_property(this, "lastEventAt", void 0), /**
   * @generated from field: int32 event_count = 3;
   */ _define_property(this, "eventCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeTimelineSummary, "runtime", proto3);
_define_property(ExecutionScopeTimelineSummary, "typeName", "mono.ryugu.v1.ExecutionScopeTimelineSummary");
_define_property(ExecutionScopeTimelineSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "first_event_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "last_event_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "event_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ExecutionScopeCoverageRow is one GetExecutionScopeCoverage matrix row.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeCoverageRow
 */ export class ExecutionScopeCoverageRow extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeCoverageRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeCoverageRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeCoverageRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeCoverageRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string commitment_id = 1;
   */ _define_property(this, "commitmentId", ""), /**
   * @generated from field: string canonical_requirement = 2;
   */ _define_property(this, "canonicalRequirement", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: mono.common.v1.ExecutionPerformanceDisposition disposition = 4;
   */ _define_property(this, "disposition", ExecutionPerformanceDisposition.UNSPECIFIED), /**
   * @generated from field: mono.common.v1.ExecutionTrackingMode tracking_mode = 5;
   */ _define_property(this, "trackingMode", ExecutionTrackingMode.UNSPECIFIED), /**
   * @generated from field: string program_task_id = 6;
   */ _define_property(this, "programTaskId", ""), /**
   * @generated from field: string source_reference_id = 7;
   */ _define_property(this, "sourceReferenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeCoverageRow, "runtime", proto3);
_define_property(ExecutionScopeCoverageRow, "typeName", "mono.ryugu.v1.ExecutionScopeCoverageRow");
_define_property(ExecutionScopeCoverageRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "commitment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "canonical_requirement",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "disposition",
            kind: "enum",
            T: proto3.getEnumType(ExecutionPerformanceDisposition)
        },
        {
            no: 5,
            name: "tracking_mode",
            kind: "enum",
            T: proto3.getEnumType(ExecutionTrackingMode)
        },
        {
            no: 6,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ExecutionScopeTimelineEvent is one GetExecutionScopeTimeline row.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeTimelineEvent
 */ export class ExecutionScopeTimelineEvent extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeTimelineEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeTimelineEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeTimelineEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeTimelineEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string event_id = 1;
   */ _define_property(this, "eventId", ""), /**
   * @generated from field: mono.common.v1.ExecutionAuthorityEventType event_type = 2;
   */ _define_property(this, "eventType", ExecutionAuthorityEventType.UNSPECIFIED), /**
   * @generated from field: google.protobuf.Timestamp business_effective_at = 3;
   */ _define_property(this, "businessEffectiveAt", void 0), /**
   * @generated from field: string change_set_id = 4;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string summary = 5;
   */ _define_property(this, "summary", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeTimelineEvent, "runtime", proto3);
_define_property(ExecutionScopeTimelineEvent, "typeName", "mono.ryugu.v1.ExecutionScopeTimelineEvent");
_define_property(ExecutionScopeTimelineEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "event_type",
            kind: "enum",
            T: proto3.getEnumType(ExecutionAuthorityEventType)
        },
        {
            no: 3,
            name: "business_effective_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ExecutionScopeProposalItem is one staged claim awaiting review.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopeProposalItem
 */ export class ExecutionScopeProposalItem extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopeProposalItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopeProposalItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopeProposalItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopeProposalItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string claim_id = 1;
   */ _define_property(this, "claimId", ""), /**
   * @generated from field: mono.common.v1.ExecutionClaimType claim_type = 2;
   */ _define_property(this, "claimType", ExecutionClaimType.UNSPECIFIED), /**
   * @generated from field: string subject_provisional_key = 3;
   */ _define_property(this, "subjectProvisionalKey", ""), /**
   * @generated from field: mono.common.v1.ExecutionReviewRequirement review_requirement = 4;
   */ _define_property(this, "reviewRequirement", ExecutionReviewRequirement.UNSPECIFIED), /**
   * @generated from field: mono.common.v1.ExecutionEntityLinkVerdict link_verdict = 5;
   */ _define_property(this, "linkVerdict", ExecutionEntityLinkVerdict.UNSPECIFIED), /**
   * @generated from field: string resolved_object_id = 6;
   */ _define_property(this, "resolvedObjectId", ""), /**
   * @generated from field: repeated string source_reference_ids = 7;
   */ _define_property(this, "sourceReferenceIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopeProposalItem, "runtime", proto3);
_define_property(ExecutionScopeProposalItem, "typeName", "mono.ryugu.v1.ExecutionScopeProposalItem");
_define_property(ExecutionScopeProposalItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claim_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "claim_type",
            kind: "enum",
            T: proto3.getEnumType(ExecutionClaimType)
        },
        {
            no: 3,
            name: "subject_provisional_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "review_requirement",
            kind: "enum",
            T: proto3.getEnumType(ExecutionReviewRequirement)
        },
        {
            no: 5,
            name: "link_verdict",
            kind: "enum",
            T: proto3.getEnumType(ExecutionEntityLinkVerdict)
        },
        {
            no: 6,
            name: "resolved_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_reference_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * ExecutionScopePressureItem is a scope-growth / out-of-scope work item.
 *
 * @generated from message mono.ryugu.v1.ExecutionScopePressureItem
 */ export class ExecutionScopePressureItem extends Message {
    static fromBinary(bytes, options) {
        return new ExecutionScopePressureItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExecutionScopePressureItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExecutionScopePressureItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExecutionScopePressureItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string work_item_id = 1;
   */ _define_property(this, "workItemId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: mono.common.v1.ExecutionScopeAssessment scope_assessment = 3;
   */ _define_property(this, "scopeAssessment", ExecutionScopeAssessment.UNSPECIFIED), /**
   * @generated from field: mono.common.v1.ExecutionCommercialTreatment commercial_treatment = 4;
   */ _define_property(this, "commercialTreatment", ExecutionCommercialTreatment.UNSPECIFIED), /**
   * @generated from field: string execution_scope_id = 5;
   */ _define_property(this, "executionScopeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExecutionScopePressureItem, "runtime", proto3);
_define_property(ExecutionScopePressureItem, "typeName", "mono.ryugu.v1.ExecutionScopePressureItem");
_define_property(ExecutionScopePressureItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "work_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope_assessment",
            kind: "enum",
            T: proto3.getEnumType(ExecutionScopeAssessment)
        },
        {
            no: 4,
            name: "commercial_treatment",
            kind: "enum",
            T: proto3.getEnumType(ExecutionCommercialTreatment)
        },
        {
            no: 5,
            name: "execution_scope_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * UnallocatedAuthorityItem is an optional-task exercise with no scope allocation.
 *
 * @generated from message mono.ryugu.v1.UnallocatedAuthorityItem
 */ export class UnallocatedAuthorityItem extends Message {
    static fromBinary(bytes, options) {
        return new UnallocatedAuthorityItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnallocatedAuthorityItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnallocatedAuthorityItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnallocatedAuthorityItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string optional_task_exercise_id = 1;
   */ _define_property(this, "optionalTaskExerciseId", ""), /**
   * @generated from field: string optional_task_id = 2;
   */ _define_property(this, "optionalTaskId", ""), /**
   * @generated from field: string modification_id = 3;
   */ _define_property(this, "modificationId", ""), /**
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: double amount = 5;
   */ _define_property(this, "amount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnallocatedAuthorityItem, "runtime", proto3);
_define_property(UnallocatedAuthorityItem, "typeName", "mono.ryugu.v1.UnallocatedAuthorityItem");
_define_property(UnallocatedAuthorityItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "optional_task_exercise_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "optional_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * ListExecutionScopesRequest lists workstreams for one program.
 *
 * @generated from message mono.ryugu.v1.ListExecutionScopesRequest
 */ export class ListExecutionScopesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListExecutionScopesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListExecutionScopesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListExecutionScopesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListExecutionScopesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListExecutionScopesRequest, "runtime", proto3);
_define_property(ListExecutionScopesRequest, "typeName", "mono.ryugu.v1.ListExecutionScopesRequest");
_define_property(ListExecutionScopesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ListExecutionScopesResponse is the workstream roster.
 *
 * @generated from message mono.ryugu.v1.ListExecutionScopesResponse
 */ export class ListExecutionScopesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListExecutionScopesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListExecutionScopesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListExecutionScopesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListExecutionScopesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ExecutionScopeSummary scopes = 1;
   */ _define_property(this, "scopes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListExecutionScopesResponse, "runtime", proto3);
_define_property(ListExecutionScopesResponse, "typeName", "mono.ryugu.v1.ListExecutionScopesResponse");
_define_property(ListExecutionScopesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scopes",
            kind: "message",
            T: ExecutionScopeSummary,
            repeated: true
        }
    ]));
/**
 * GetExecutionScopeRequest loads one workstream aggregate.
 *
 * @generated from message mono.ryugu.v1.GetExecutionScopeRequest
 */ export class GetExecutionScopeRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetExecutionScopeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExecutionScopeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExecutionScopeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExecutionScopeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExecutionScopeRequest, "runtime", proto3);
_define_property(GetExecutionScopeRequest, "typeName", "mono.ryugu.v1.GetExecutionScopeRequest");
_define_property(GetExecutionScopeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * GetExecutionScopeResponse is the aggregate read.
 *
 * @generated from message mono.ryugu.v1.GetExecutionScopeResponse
 */ export class GetExecutionScopeResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetExecutionScopeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExecutionScopeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExecutionScopeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExecutionScopeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ExecutionScopeAggregate scope = 1;
   */ _define_property(this, "scope", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExecutionScopeResponse, "runtime", proto3);
_define_property(GetExecutionScopeResponse, "typeName", "mono.ryugu.v1.GetExecutionScopeResponse");
_define_property(GetExecutionScopeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope",
            kind: "message",
            T: ExecutionScopeAggregate
        }
    ]));
/**
 * GetExecutionScopeTimelineRequest loads the authority/revision timeline.
 *
 * @generated from message mono.ryugu.v1.GetExecutionScopeTimelineRequest
 */ export class GetExecutionScopeTimelineRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetExecutionScopeTimelineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExecutionScopeTimelineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExecutionScopeTimelineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExecutionScopeTimelineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string execution_scope_id = 2;
   */ _define_property(this, "executionScopeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExecutionScopeTimelineRequest, "runtime", proto3);
_define_property(GetExecutionScopeTimelineRequest, "typeName", "mono.ryugu.v1.GetExecutionScopeTimelineRequest");
_define_property(GetExecutionScopeTimelineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "execution_scope_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * GetExecutionScopeTimelineResponse is the timeline.
 *
 * @generated from message mono.ryugu.v1.GetExecutionScopeTimelineResponse
 */ export class GetExecutionScopeTimelineResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetExecutionScopeTimelineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExecutionScopeTimelineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExecutionScopeTimelineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExecutionScopeTimelineResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ExecutionScopeTimelineEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExecutionScopeTimelineResponse, "runtime", proto3);
_define_property(GetExecutionScopeTimelineResponse, "typeName", "mono.ryugu.v1.GetExecutionScopeTimelineResponse");
_define_property(GetExecutionScopeTimelineResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: ExecutionScopeTimelineEvent,
            repeated: true
        }
    ]));
/**
 * GetExecutionScopeCoverageRequest loads the coverage matrix.
 *
 * @generated from message mono.ryugu.v1.GetExecutionScopeCoverageRequest
 */ export class GetExecutionScopeCoverageRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetExecutionScopeCoverageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExecutionScopeCoverageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExecutionScopeCoverageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExecutionScopeCoverageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string execution_scope_id = 2;
   */ _define_property(this, "executionScopeId", ""), /**
   * @generated from field: string revision_id = 3;
   */ _define_property(this, "revisionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExecutionScopeCoverageRequest, "runtime", proto3);
_define_property(GetExecutionScopeCoverageRequest, "typeName", "mono.ryugu.v1.GetExecutionScopeCoverageRequest");
_define_property(GetExecutionScopeCoverageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "execution_scope_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "revision_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * GetExecutionScopeCoverageResponse is the coverage matrix.
 *
 * @generated from message mono.ryugu.v1.GetExecutionScopeCoverageResponse
 */ export class GetExecutionScopeCoverageResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetExecutionScopeCoverageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExecutionScopeCoverageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExecutionScopeCoverageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExecutionScopeCoverageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ExecutionScopeCoverageRow rows = 1;
   */ _define_property(this, "rows", []), /**
   * @generated from field: mono.ryugu.v1.ExecutionScopeCommitmentCounts counts = 2;
   */ _define_property(this, "counts", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExecutionScopeCoverageResponse, "runtime", proto3);
_define_property(GetExecutionScopeCoverageResponse, "typeName", "mono.ryugu.v1.GetExecutionScopeCoverageResponse");
_define_property(GetExecutionScopeCoverageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: ExecutionScopeCoverageRow,
            repeated: true
        },
        {
            no: 2,
            name: "counts",
            kind: "message",
            T: ExecutionScopeCommitmentCounts
        }
    ]));
/**
 * CreateManualExecutionScopeRequest creates a draft workstream without extraction.
 *
 * @generated from message mono.ryugu.v1.CreateManualExecutionScopeRequest
 */ export class CreateManualExecutionScopeRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateManualExecutionScopeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateManualExecutionScopeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateManualExecutionScopeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateManualExecutionScopeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string scope_type = 3;
   */ _define_property(this, "scopeType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateManualExecutionScopeRequest, "runtime", proto3);
_define_property(CreateManualExecutionScopeRequest, "typeName", "mono.ryugu.v1.CreateManualExecutionScopeRequest");
_define_property(CreateManualExecutionScopeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CreateManualExecutionScopeResponse returns the created draft.
 *
 * @generated from message mono.ryugu.v1.CreateManualExecutionScopeResponse
 */ export class CreateManualExecutionScopeResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateManualExecutionScopeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateManualExecutionScopeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateManualExecutionScopeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateManualExecutionScopeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ExecutionScopeSummary scope = 1;
   */ _define_property(this, "scope", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateManualExecutionScopeResponse, "runtime", proto3);
_define_property(CreateManualExecutionScopeResponse, "typeName", "mono.ryugu.v1.CreateManualExecutionScopeResponse");
_define_property(CreateManualExecutionScopeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope",
            kind: "message",
            T: ExecutionScopeSummary
        }
    ]));
/**
 * UpdateManualExecutionScopeDraftRequest updates a draft workstream.
 *
 * @generated from message mono.ryugu.v1.UpdateManualExecutionScopeDraftRequest
 */ export class UpdateManualExecutionScopeDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateManualExecutionScopeDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateManualExecutionScopeDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateManualExecutionScopeDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateManualExecutionScopeDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string display_name = 3;
   */ _define_property(this, "displayName", ""), /**
   * @generated from field: string scope_type = 4;
   */ _define_property(this, "scopeType", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateManualExecutionScopeDraftRequest, "runtime", proto3);
_define_property(UpdateManualExecutionScopeDraftRequest, "typeName", "mono.ryugu.v1.UpdateManualExecutionScopeDraftRequest");
_define_property(UpdateManualExecutionScopeDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * UpdateManualExecutionScopeDraftResponse returns the updated draft.
 *
 * @generated from message mono.ryugu.v1.UpdateManualExecutionScopeDraftResponse
 */ export class UpdateManualExecutionScopeDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateManualExecutionScopeDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateManualExecutionScopeDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateManualExecutionScopeDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateManualExecutionScopeDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ExecutionScopeSummary scope = 1;
   */ _define_property(this, "scope", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateManualExecutionScopeDraftResponse, "runtime", proto3);
_define_property(UpdateManualExecutionScopeDraftResponse, "typeName", "mono.ryugu.v1.UpdateManualExecutionScopeDraftResponse");
_define_property(UpdateManualExecutionScopeDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope",
            kind: "message",
            T: ExecutionScopeSummary
        }
    ]));
/**
 * StageExecutionScopeArtifactRequest starts import of a governing artifact.
 *
 * @generated from message mono.ryugu.v1.StageExecutionScopeArtifactRequest
 */ export class StageExecutionScopeArtifactRequest extends Message {
    static fromBinary(bytes, options) {
        return new StageExecutionScopeArtifactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StageExecutionScopeArtifactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StageExecutionScopeArtifactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StageExecutionScopeArtifactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string artifact_version_id = 3;
   */ _define_property(this, "artifactVersionId", ""), /**
   * S8 SOW intake: the converted SOW/EP (reverie's per-doc blocks), and the
   * tenant for the principal-less pipeline lane (a caller's principal wins).
   *
   * @generated from field: string company_id = 4;
   */ _define_property(this, "companyId", ""), /**
   * @generated from field: string project_id = 5;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string doc_id = 6;
   */ _define_property(this, "docId", ""), /**
   * @generated from field: string blocks_path = 7;
   */ _define_property(this, "blocksPath", ""), /**
   * @generated from field: string title = 8;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StageExecutionScopeArtifactRequest, "runtime", proto3);
_define_property(StageExecutionScopeArtifactRequest, "typeName", "mono.ryugu.v1.StageExecutionScopeArtifactRequest");
_define_property(StageExecutionScopeArtifactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "doc_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "blocks_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * StageExecutionScopeArtifactResponse returns the staged ChangeSet.
 *
 * @generated from message mono.ryugu.v1.StageExecutionScopeArtifactResponse
 */ export class StageExecutionScopeArtifactResponse extends Message {
    static fromBinary(bytes, options) {
        return new StageExecutionScopeArtifactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StageExecutionScopeArtifactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StageExecutionScopeArtifactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StageExecutionScopeArtifactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: mono.common.v1.ExecutionContractChangeSetType change_set_type = 2;
   */ _define_property(this, "changeSetType", ExecutionContractChangeSetType.UNSPECIFIED), /**
   * S8: the SOW written, and whether robin read the document at all (false
   * when the tenant's robin_extraction flag is off).
   *
   * @generated from field: string sow_id = 3;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: bool read = 4;
   */ _define_property(this, "read", false), /**
   * @generated from field: string skipped_reason = 5;
   */ _define_property(this, "skippedReason", ""), /**
   * @generated from field: int32 assignments = 6;
   */ _define_property(this, "assignments", 0), /**
   * @generated from field: int32 work_products = 7;
   */ _define_property(this, "workProducts", 0), /**
   * @generated from field: int32 review_items = 8;
   */ _define_property(this, "reviewItems", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StageExecutionScopeArtifactResponse, "runtime", proto3);
_define_property(StageExecutionScopeArtifactResponse, "typeName", "mono.ryugu.v1.StageExecutionScopeArtifactResponse");
_define_property(StageExecutionScopeArtifactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_type",
            kind: "enum",
            T: proto3.getEnumType(ExecutionContractChangeSetType)
        },
        {
            no: 3,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "read",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "skipped_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "assignments",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "work_products",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "review_items",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * StageExecutionScopeCorrectionRequest stages one ExecutionScopeManualCorrection
 * ChangeSet against a workstream — the browser door to the canonical SDS
 * gateway CRUD (Lane F part 2). Items conform to the apply registry's payload
 * contract: creates (empty field_path) carry a flat JSON object, field updates
 * carry the bare JSON value; the strict apply preflight remains the final word.
 *
 * @generated from message mono.ryugu.v1.StageExecutionScopeCorrectionRequest
 */ export class StageExecutionScopeCorrectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new StageExecutionScopeCorrectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StageExecutionScopeCorrectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StageExecutionScopeCorrectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StageExecutionScopeCorrectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string execution_scope_id = 2;
   */ _define_property(this, "executionScopeId", ""), /**
   * @generated from field: repeated mono.ryugu.v1.StageExecutionScopeCorrectionRequest.CorrectionItem items = 3;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StageExecutionScopeCorrectionRequest, "runtime", proto3);
_define_property(StageExecutionScopeCorrectionRequest, "typeName", "mono.ryugu.v1.StageExecutionScopeCorrectionRequest");
_define_property(StageExecutionScopeCorrectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "execution_scope_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "items",
            kind: "message",
            T: StageExecutionScopeCorrectionRequest_CorrectionItem,
            repeated: true
        }
    ]));
/**
 * CorrectionItem is one proposed create/update on a registered target.
 *
 * @generated from message mono.ryugu.v1.StageExecutionScopeCorrectionRequest.CorrectionItem
 */ export class StageExecutionScopeCorrectionRequest_CorrectionItem extends Message {
    static fromBinary(bytes, options) {
        return new StageExecutionScopeCorrectionRequest_CorrectionItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StageExecutionScopeCorrectionRequest_CorrectionItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StageExecutionScopeCorrectionRequest_CorrectionItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StageExecutionScopeCorrectionRequest_CorrectionItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string target_object_type = 1;
   */ _define_property(this, "targetObjectType", ""), /**
   * empty for creates
   *
   * @generated from field: string target_object_id = 2;
   */ _define_property(this, "targetObjectId", ""), /**
   * empty for creates
   *
   * @generated from field: string field_path = 3;
   */ _define_property(this, "fieldPath", ""), /**
   * @generated from field: string proposed_value_json = 4;
   */ _define_property(this, "proposedValueJson", ""), /**
   * @generated from field: string rationale = 5;
   */ _define_property(this, "rationale", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(StageExecutionScopeCorrectionRequest_CorrectionItem, "runtime", proto3);
_define_property(StageExecutionScopeCorrectionRequest_CorrectionItem, "typeName", "mono.ryugu.v1.StageExecutionScopeCorrectionRequest.CorrectionItem");
_define_property(StageExecutionScopeCorrectionRequest_CorrectionItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "target_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "field_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proposed_value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * StageExecutionScopeCorrectionResponse returns the staged set and its items.
 *
 * @generated from message mono.ryugu.v1.StageExecutionScopeCorrectionResponse
 */ export class StageExecutionScopeCorrectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new StageExecutionScopeCorrectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StageExecutionScopeCorrectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StageExecutionScopeCorrectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StageExecutionScopeCorrectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: repeated string item_ids = 2;
   */ _define_property(this, "itemIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StageExecutionScopeCorrectionResponse, "runtime", proto3);
_define_property(StageExecutionScopeCorrectionResponse, "typeName", "mono.ryugu.v1.StageExecutionScopeCorrectionResponse");
_define_property(StageExecutionScopeCorrectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "item_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * GetExecutionScopeImportReviewRequest loads a staged import for review.
 *
 * @generated from message mono.ryugu.v1.GetExecutionScopeImportReviewRequest
 */ export class GetExecutionScopeImportReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetExecutionScopeImportReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExecutionScopeImportReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExecutionScopeImportReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExecutionScopeImportReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExecutionScopeImportReviewRequest, "runtime", proto3);
_define_property(GetExecutionScopeImportReviewRequest, "typeName", "mono.ryugu.v1.GetExecutionScopeImportReviewRequest");
_define_property(GetExecutionScopeImportReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * GetExecutionScopeImportReviewResponse is the review surface.
 *
 * @generated from message mono.ryugu.v1.GetExecutionScopeImportReviewResponse
 */ export class GetExecutionScopeImportReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetExecutionScopeImportReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetExecutionScopeImportReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetExecutionScopeImportReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetExecutionScopeImportReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: repeated mono.ryugu.v1.ExecutionScopeProposalItem items = 2;
   */ _define_property(this, "items", []), /**
   * @generated from field: int32 unresolved_count = 3;
   */ _define_property(this, "unresolvedCount", 0), /**
   * @generated from field: int32 blocking_review_count = 4;
   */ _define_property(this, "blockingReviewCount", 0), /**
   * Lifecycle state of the set (Draft|UnderReview|Approved|Applied|...). The
   * reviewer surface needs it to tell "still deciding" from "already done":
   * an applied set has nothing left blocking it, and rendering preflight
   * blockers for one reads as failure when it is success.
   *
   * @generated from field: string change_set_state = 5;
   */ _define_property(this, "changeSetState", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetExecutionScopeImportReviewResponse, "runtime", proto3);
_define_property(GetExecutionScopeImportReviewResponse, "typeName", "mono.ryugu.v1.GetExecutionScopeImportReviewResponse");
_define_property(GetExecutionScopeImportReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: ExecutionScopeProposalItem,
            repeated: true
        },
        {
            no: 3,
            name: "unresolved_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "blocking_review_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "change_set_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ResolveExecutionScopeProposalRequest records a reviewer decision on one claim.
 *
 * @generated from message mono.ryugu.v1.ResolveExecutionScopeProposalRequest
 */ export class ResolveExecutionScopeProposalRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveExecutionScopeProposalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveExecutionScopeProposalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveExecutionScopeProposalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveExecutionScopeProposalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string claim_id = 3;
   */ _define_property(this, "claimId", ""), /**
   * @generated from field: mono.common.v1.ExecutionEntityLinkVerdict verdict = 4;
   */ _define_property(this, "verdict", ExecutionEntityLinkVerdict.UNSPECIFIED), /**
   * @generated from field: string resolved_object_id = 5;
   */ _define_property(this, "resolvedObjectId", ""), /**
   * @generated from field: string rationale = 6;
   */ _define_property(this, "rationale", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveExecutionScopeProposalRequest, "runtime", proto3);
_define_property(ResolveExecutionScopeProposalRequest, "typeName", "mono.ryugu.v1.ResolveExecutionScopeProposalRequest");
_define_property(ResolveExecutionScopeProposalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "claim_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "verdict",
            kind: "enum",
            T: proto3.getEnumType(ExecutionEntityLinkVerdict)
        },
        {
            no: 5,
            name: "resolved_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ResolveExecutionScopeProposalResponse returns the updated proposal item.
 *
 * @generated from message mono.ryugu.v1.ResolveExecutionScopeProposalResponse
 */ export class ResolveExecutionScopeProposalResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveExecutionScopeProposalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveExecutionScopeProposalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveExecutionScopeProposalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveExecutionScopeProposalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.ryugu.v1.ExecutionScopeProposalItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveExecutionScopeProposalResponse, "runtime", proto3);
_define_property(ResolveExecutionScopeProposalResponse, "typeName", "mono.ryugu.v1.ResolveExecutionScopeProposalResponse");
_define_property(ResolveExecutionScopeProposalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: ExecutionScopeProposalItem
        }
    ]));
/**
 * PreviewExecutionScopeApplyRequest previews apply impact without writing.
 *
 * @generated from message mono.ryugu.v1.PreviewExecutionScopeApplyRequest
 */ export class PreviewExecutionScopeApplyRequest extends Message {
    static fromBinary(bytes, options) {
        return new PreviewExecutionScopeApplyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewExecutionScopeApplyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewExecutionScopeApplyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewExecutionScopeApplyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewExecutionScopeApplyRequest, "runtime", proto3);
_define_property(PreviewExecutionScopeApplyRequest, "typeName", "mono.ryugu.v1.PreviewExecutionScopeApplyRequest");
_define_property(PreviewExecutionScopeApplyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * PreviewExecutionScopeApplyResponse is the impact preview.
 *
 * @generated from message mono.ryugu.v1.PreviewExecutionScopeApplyResponse
 */ export class PreviewExecutionScopeApplyResponse extends Message {
    static fromBinary(bytes, options) {
        return new PreviewExecutionScopeApplyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewExecutionScopeApplyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewExecutionScopeApplyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewExecutionScopeApplyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 objects_created = 1;
   */ _define_property(this, "objectsCreated", 0), /**
   * @generated from field: int32 objects_updated = 2;
   */ _define_property(this, "objectsUpdated", 0), /**
   * @generated from field: int32 instances_created = 3;
   */ _define_property(this, "instancesCreated", 0), /**
   * @generated from field: int32 instances_retained = 4;
   */ _define_property(this, "instancesRetained", 0), /**
   * @generated from field: repeated string warnings = 5;
   */ _define_property(this, "warnings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewExecutionScopeApplyResponse, "runtime", proto3);
_define_property(PreviewExecutionScopeApplyResponse, "typeName", "mono.ryugu.v1.PreviewExecutionScopeApplyResponse");
_define_property(PreviewExecutionScopeApplyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "objects_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "objects_updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "instances_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "instances_retained",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * ApproveExecutionScopeChangeSetRequest closes the review on a staged set.
 *
 * @generated from message mono.ryugu.v1.ApproveExecutionScopeChangeSetRequest
 */ export class ApproveExecutionScopeChangeSetRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApproveExecutionScopeChangeSetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveExecutionScopeChangeSetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveExecutionScopeChangeSetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveExecutionScopeChangeSetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveExecutionScopeChangeSetRequest, "runtime", proto3);
_define_property(ApproveExecutionScopeChangeSetRequest, "typeName", "mono.ryugu.v1.ApproveExecutionScopeChangeSetRequest");
_define_property(ApproveExecutionScopeChangeSetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ApproveExecutionScopeChangeSetResponse reports the resulting set state and,
 * when the set contained a change that REMOVES a delivery obligation, that
 * dual control applied and which items forced it. blocking_reasons is populated
 * whenever dual_control_required is true, so the browser can say WHY a second
 * approver was needed rather than showing an unexplained extra step.
 *
 * @generated from message mono.ryugu.v1.ApproveExecutionScopeChangeSetResponse
 */ export class ApproveExecutionScopeChangeSetResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApproveExecutionScopeChangeSetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveExecutionScopeChangeSetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveExecutionScopeChangeSetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveExecutionScopeChangeSetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string state = 2;
   */ _define_property(this, "state", ""), /**
   * @generated from field: bool dual_control_required = 3;
   */ _define_property(this, "dualControlRequired", false), /**
   * @generated from field: repeated string blocking_reasons = 4;
   */ _define_property(this, "blockingReasons", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveExecutionScopeChangeSetResponse, "runtime", proto3);
_define_property(ApproveExecutionScopeChangeSetResponse, "typeName", "mono.ryugu.v1.ApproveExecutionScopeChangeSetResponse");
_define_property(ApproveExecutionScopeChangeSetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "dual_control_required",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "blocking_reasons",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * ApplyExecutionScopeChangeSetRequest commits a reviewed import/revision.
 *
 * @generated from message mono.ryugu.v1.ApplyExecutionScopeChangeSetRequest
 */ export class ApplyExecutionScopeChangeSetRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApplyExecutionScopeChangeSetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyExecutionScopeChangeSetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyExecutionScopeChangeSetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyExecutionScopeChangeSetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string change_set_id = 2;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string correlation_id = 3;
   */ _define_property(this, "correlationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyExecutionScopeChangeSetRequest, "runtime", proto3);
_define_property(ApplyExecutionScopeChangeSetRequest, "typeName", "mono.ryugu.v1.ApplyExecutionScopeChangeSetRequest");
_define_property(ApplyExecutionScopeChangeSetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "correlation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ApplyExecutionScopeChangeSetResponse is the apply summary.
 *
 * @generated from message mono.ryugu.v1.ApplyExecutionScopeChangeSetResponse
 */ export class ApplyExecutionScopeChangeSetResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApplyExecutionScopeChangeSetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyExecutionScopeChangeSetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyExecutionScopeChangeSetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyExecutionScopeChangeSetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: int32 applied_count = 2;
   */ _define_property(this, "appliedCount", 0), /**
   * @generated from field: int32 skipped_count = 3;
   */ _define_property(this, "skippedCount", 0), /**
   * @generated from field: repeated string warnings = 4;
   */ _define_property(this, "warnings", []), /**
   * @generated from field: string applied_event_id = 5;
   */ _define_property(this, "appliedEventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyExecutionScopeChangeSetResponse, "runtime", proto3);
_define_property(ApplyExecutionScopeChangeSetResponse, "typeName", "mono.ryugu.v1.ApplyExecutionScopeChangeSetResponse");
_define_property(ApplyExecutionScopeChangeSetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "applied_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "skipped_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "applied_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ListUnallocatedAuthorityRequest lists exercises with no scope allocation.
 *
 * @generated from message mono.ryugu.v1.ListUnallocatedAuthorityRequest
 */ export class ListUnallocatedAuthorityRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListUnallocatedAuthorityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListUnallocatedAuthorityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListUnallocatedAuthorityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListUnallocatedAuthorityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListUnallocatedAuthorityRequest, "runtime", proto3);
_define_property(ListUnallocatedAuthorityRequest, "typeName", "mono.ryugu.v1.ListUnallocatedAuthorityRequest");
_define_property(ListUnallocatedAuthorityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ListUnallocatedAuthorityResponse is the unallocated-authority roster.
 *
 * @generated from message mono.ryugu.v1.ListUnallocatedAuthorityResponse
 */ export class ListUnallocatedAuthorityResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListUnallocatedAuthorityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListUnallocatedAuthorityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListUnallocatedAuthorityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListUnallocatedAuthorityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.UnallocatedAuthorityItem items = 1;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListUnallocatedAuthorityResponse, "runtime", proto3);
_define_property(ListUnallocatedAuthorityResponse, "typeName", "mono.ryugu.v1.ListUnallocatedAuthorityResponse");
_define_property(ListUnallocatedAuthorityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: UnallocatedAuthorityItem,
            repeated: true
        }
    ]));
/**
 * ListScopePressureItemsRequest lists work products / scope-growth items.
 *
 * @generated from message mono.ryugu.v1.ListScopePressureItemsRequest
 */ export class ListScopePressureItemsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListScopePressureItemsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListScopePressureItemsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListScopePressureItemsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListScopePressureItemsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListScopePressureItemsRequest, "runtime", proto3);
_define_property(ListScopePressureItemsRequest, "typeName", "mono.ryugu.v1.ListScopePressureItemsRequest");
_define_property(ListScopePressureItemsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ListScopePressureItemsResponse is the scope-pressure roster.
 *
 * @generated from message mono.ryugu.v1.ListScopePressureItemsResponse
 */ export class ListScopePressureItemsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListScopePressureItemsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListScopePressureItemsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListScopePressureItemsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListScopePressureItemsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.ryugu.v1.ExecutionScopePressureItem items = 1;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListScopePressureItemsResponse, "runtime", proto3);
_define_property(ListScopePressureItemsResponse, "typeName", "mono.ryugu.v1.ListScopePressureItemsResponse");
_define_property(ListScopePressureItemsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: ExecutionScopePressureItem,
            repeated: true
        }
    ]));
/**
 * BulkStageScopeDeviationRequest stages one or more scope deviations.
 *
 * @generated from message mono.ryugu.v1.BulkStageScopeDeviationRequest
 */ export class BulkStageScopeDeviationRequest extends Message {
    static fromBinary(bytes, options) {
        return new BulkStageScopeDeviationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BulkStageScopeDeviationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BulkStageScopeDeviationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BulkStageScopeDeviationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: repeated string commitment_ids = 2;
   */ _define_property(this, "commitmentIds", []), /**
   * @generated from field: string rationale = 3;
   */ _define_property(this, "rationale", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BulkStageScopeDeviationRequest, "runtime", proto3);
_define_property(BulkStageScopeDeviationRequest, "typeName", "mono.ryugu.v1.BulkStageScopeDeviationRequest");
_define_property(BulkStageScopeDeviationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "commitment_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * BulkStageScopeDeviationResponse returns the staged ChangeSet.
 *
 * @generated from message mono.ryugu.v1.BulkStageScopeDeviationResponse
 */ export class BulkStageScopeDeviationResponse extends Message {
    static fromBinary(bytes, options) {
        return new BulkStageScopeDeviationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BulkStageScopeDeviationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BulkStageScopeDeviationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BulkStageScopeDeviationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: int32 staged_count = 2;
   */ _define_property(this, "stagedCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BulkStageScopeDeviationResponse, "runtime", proto3);
_define_property(BulkStageScopeDeviationResponse, "typeName", "mono.ryugu.v1.BulkStageScopeDeviationResponse");
_define_property(BulkStageScopeDeviationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "staged_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
